import React from 'react';
import { classnames as cx } from '../../utilities';

import './RVDivider.scss';

const RVDivider = className => (
  <div className={cx('rvdivider', className)}></div>
);

export default RVDivider;
